<template>
  <dl @click.prevent="goDetail(cellInfo)">
    <dt>
      <a href="#">
        <div class="thumb-image">
          <img  v-lazy="getLazyLoadObj(thumbnail)" class="thumb" :alt="title" />
          <div class="tag-top tag-list">
            <div class="tag-bottom tag-list" v-if="hasBottomTagList" v-bottom-tag-list="bottomTagList"></div>
          </div>
        </div>
        <!-- TODO: 플레이어 재생 표시 -->
        <div :class="vodPlayNowClass"></div>
      </a>
    </dt>
    <dd>
      <a href="#">
        <strong>{{ title }}</strong>
        <span class="metadata">{{ subTitle }}</span>
      </a>
    </dd>
  </dl>
</template>

<script>
  import _ from 'lodash'
  import { addPostfixAndUrl } from '@/common/utils/common'
  import { parseUrl } from 'query-string'
  import CellMixIn from '@/mixins/cell.mixin'
  import { bottomTagList } from '@/common/resources/directives'
  import { resizeThumbnail } from '@/common/utils/image'
  export default {
    name: 'ThumbAllHighlight',
    filters: {
      addPostfixAndUrl
    },
    mixins: [
      CellMixIn
    ],
    directives: {
      bottomTagList
    },
    props: {
      cellInfo: {
        type: Object
      },
      currentContentId: {
        type: String
      }
    },
    data () {
      return {
        placeholderImage: require('../../../assets/images/common/img_default_thum_2.png')
      }
    },
    computed: {
      thumbnail () {
        return _.get(this.cellInfo, 'thumbnail', '')
      },
      title () {
        return _.get(this.cellInfo, 'title_list.0.text', '')
      },
      subTitle () {
        return _.get(this.cellInfo, 'title_list.1.text', '')
      },
      contentId () {
        return _.get(this.cellInfo, 'contentid', '')
      },
      vodPlayNowClass () {
        const { query } = parseUrl(_.get(this.cellInfo, 'event_list.1.url', ''))
        return this.currentContentId === _.get(query, 'contentid', '') ? 'vod-play-now' : ''
      }
    },
    methods: {
      getLazyLoadObj (img) {
        return {
          src: resizeThumbnail(img, { width: 242, height: 136, isSquare: false }),
          error: this.placeholderImage,
          loading: this.placeholderImage
        }
      }
    }
  }
</script>
<style>
  .player-component01 .week6-synopsis{
    display: block;
    height: 22px;
    margin-bottom: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
  }
  .player-component01 .week6-text{
    font-size: 14px;
    line-height: 20px;
    color: #fff;
  }
  .vod-play-now:after{
    content: '';
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.3) url("../../../assets/images/common/ic-now-play.png") center no-repeat;
  }
</style>
